__turbopack_context__.v({
  "safety-tips-icon": "index-module-scss-module__JYSCPq__safety-tips-icon",
  "safety-tips-wrapper": "index-module-scss-module__JYSCPq__safety-tips-wrapper",
});
